import { observable, action, autorun, computed, toJS } from 'mobx'
import http from 'src/helper/http'
import axios from 'axios'
const env = process.env.NODE_ENV
export default class {
  @observable data = {
    adminInfo: {},
  }

  @action async AdminLogin(host, uid, token, cb, catchCb) {

    const config = {
      headers: {
        'content-type': 'application/json',
        // 'Authorization': token,
        'X-Mac': 'from-web',
        'X-Lang': 'en',
        'X-Platform': '2',
        'X-Ver': 9 || '',
        'X-Mobilephone': '',
        'X-SysVersion': '',
        'X-Ts': parseInt(Date.parse(new Date()) / 1000),
      }
    }

    let data = { uid, token }

    axios.post(`${host}/api/app/login`, data, config)
      .then(d => {

        if (d && d.code == 0) {
          this.data.adminInfo = d.result
        } else {
          catchCb && catchCb(d)
        }
        // cb && cb(d.message)

      })
      .catch(error => {
        console.error('Request failed', error);
        catchCb && catchCb(error)
      });

  }

  @action async CreateGuild(host, data, cb) {

    const config = {
      headers: {
        'content-type': 'application/json',
        'Authorization': this.data.adminInfo.token || "",
      }
    }

    await axios.post(`${host}/api/guild`, data, config)
      .then(d => {
        cb && cb(d.message)
      })
  }

  // @action async GetCountryList(host, data, cb) {

  //   const config = {
  //     headers: {
  //       'content-type': 'application/json',
  //       'Authorization': this.data.adminInfo.token || "",
  //     }
  //   }

  //   await axios.get(`${host}/api/country`, data, config)
  //     .then(d => {
  //       cb && cb(d.result && d.result.items || [])
  //     })
  // }

  @action async GetCountryList(uid, cb) {
    let d = await http.post('/withoutsign/country', { uid: uid }, null, { "X-OsLang": navigator.language || 'ar' })
    cb && cb(d && d.res && d.res.all || [])
  }

}



// WEBPACK FOOTER //
// src/store/admin-control/agency_create.js